
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Website Designers & Developers in Goa - Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Invest in web design and development services with Goa App. Our website design services creates aesthetically-striking, user-friendly, Google-approved sites.'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'web design services in goa, web development services in goa, responsive web design services, ecommerce web development services in goa, professional web development service in goa, web development services in india'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Website Designers & Developers in Goa - Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Invest in web design and development services with Goa App. Our website design services creates aesthetically-striking, user-friendly, Google-approved sites.'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Website Designers & Developers in Goa - Goa App'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Invest in web design and development services with Goa App. Our website design services creates aesthetically-striking, user-friendly, Google-approved sites.'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Website Designers & Developers in Goa - Goa App'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/website-development.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/website-development.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/website-development.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Website Designers & Developers in Goa - Goa App',
      description: 'Invest in web design and development services with Goa App. Our website design services creates aesthetically-striking, user-friendly, Google-approved sites.',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
		},
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },


jsonld() {
    return {
        '@context': 'https://schema.org',
        "@graph": [
            {
                "@type": "Service",
                "@id": "https://goa.app/website-development/#Service",
                "url": "https://goa.app/website-development",
                "name": "Website Development",
                "description": "Responsive Web Development services that every business needs. We provide SEO friendly website Design Services.",
                 "image": "https://goa.app/img/service-imgs/website-development.webp",
                "inLanguage": "en-US",
	       "datePublished": "2024-06-14T00:00:00",
	       "dateModified":  "2024-06-14T00:00:00",
                "author": {
                    "@type": "Person",
                    "@id": "https://goa.app",
                    "url": "https://goa.app"
                },
                "serviceType": "Web Development",
                "additionalType": "serviceOutput",
                "provider": {
                    "@type": "Corporation",
                    "name": "Goa App",
                    "address": {
                        "@type": "PostalAddress",
                        "addressLocality": "Goa",
                        "postalCode": "403505"
                    },
                    "telephone": "+91 9049248689"
                },
                "areaServed": {
                    "@type": "City",
                    "name": "Goa"
                },
                "hasOfferCatalog": {
                    "@type": "OfferCatalog",
                    "name": "Website Development",
                    "itemListElement": [
                        {
                            "@type": "Offer",
                            "name": "SEO-Optimized"
                        },
                        {
                            "@type": "Offer",
                            "name": "Fully Secure"
                        },
                        {
                            "@type": "Offer",
                            "name": "Responsive to all devices"
                        },
                        {
                            "@type": "Offer",
                            "name": "Seamless User-Experience"
                        },
                        {
                            "@type": "Offer",
                            "name": "E-Commerce Websites"
                        },
                        {
                            "@type": "Offer",
                            "name": "Website Maintenance"
                        },
                        {
                            "@type": "Offer",
                            "name": "Optimized for Speed"
                        },
                        {
                            "@type": "Offer",
                            "name": "Suits your unique needs"
                        }
                    ]
                }
            },
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Will my website look the same on all screens?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "While your website's desktop elements will be preserved on mobile versions, slight variations may occur due to screen size, browser resolution, and device settings. During development, we rigorously test across browsers, devices, and settings to ensure optimal performance."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Will I be able to make changes to my website once complete?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Depending on the platform used (like WordPress or Magento), Goa App provides options for extensive customization post-launch. For static websites, we offer a Content Management System (CMS) enabling updates to text, images, and new content. Complex changes may require our assistance or that of a web design agency in Goa or Mumbai."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Will my site be SEO friendly?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Goa App ensures SEO elements such as structure, speed, and content optimization are integrated during website development. While your site will be SEO-friendly, ongoing SEO services are recommended for continuous improvement and higher search engine rankings."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much does a website cost?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Website costs vary based on specific project needs, ranging from front-end/back-end requirements to e-commerce management. Goa App conducts thorough consultations to provide a tailored cost estimate, with prices typically ranging from Rs. 15,000 to Rs. 2 lakhs for high-quality websites."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long will it take to get a new website?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Goa App targets a 6-8 week turnaround for website projects, contingent upon client feedback, initial project details, content readiness, and complexity. We adhere to agreed timelines, ensuring timely delivery of fully functional websites."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Will I have to make changes to my website?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Goa App focuses on optimizing websites through code and content adjustments, aiming to enhance online rankings without major structural changes. In cases requiring significant updates, our web design and development services are recommended as a first step."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Which technologies do you use to develop my websites?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Goa App utilizes a range of platforms based on business requirements, functionality expectations, and user interactions. Proficient in HTML, CSS, JavaScript, PHP, Python, WordPress, Magento, Shopify, Bootstrap, and .NET, we tailor the technology stack to optimize your website's performance and functionality."
                        }
                    }
                ]
            }
        ]
    };
},
  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
